
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/ui",
      function () {
        return require("private-next-pages/features/ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/ui"])
      });
    }
  